import { DEFAULT_ORDER_CONFIG } from '_utils/constant'
import { useEffect } from 'react'
import { useForm } from 'react-hook-form'
import { useDispatch } from 'react-redux'
import { useToasts } from 'react-toast-notifications'
import { Modal, Spinner } from 'reactstrap'
import { editProductAction } from '../../../../redux/modules/product'
import './style.scss'

const OrderSettingModal = (props) => {
  const dispatch = useDispatch()
  const { addToast } = useToasts()
  const { isOpen, toggle, row } = props

  const {
    register,
    handleSubmit,
    reset,
    formState: { isSubmitting, errors },
  } = useForm({ defaultValues: DEFAULT_ORDER_CONFIG })

  useEffect(() => {
    if (isOpen && row) {
      reset({
        maxQuantity: row.maxQuantity ?? DEFAULT_ORDER_CONFIG.maxQuantity,
        limitPerOrder: row.limitPerOrder ?? DEFAULT_ORDER_CONFIG.limitPerOrder,
        minOrderQty: row.minOrderQty ?? DEFAULT_ORDER_CONFIG.minOrderQty,
      })
    }
  }, [isOpen, row, reset])

  const onSubmit = async (data) => {
    if (!row) {
      toggle()
      return
    }

    try {
      const { msgResp } = await dispatch(
        editProductAction(row.id, row.eventId, {
          maxQuantity: Number(data.maxQuantity),
          limitPerOrder: Number(data.limitPerOrder),
          minOrderQty: Number(data.minOrderQty),
        })
      )
      toggle()
      addToast(msgResp || 'Order configuration updated successfully', { appearance: 'success', autoDismiss: true })
    } catch (error) {
      addToast(error?.msgResp || error?.message || 'Update failed', { appearance: 'error', autoDismiss: true })
    }
  }

  const handleReset = async () => {
    if (!row) {
      toggle()
      return
    }

    try {
      const { msgResp } = await dispatch(
        editProductAction(row.id, row.eventId, {
          maxQuantity: DEFAULT_ORDER_CONFIG.maxQuantity,
          limitPerOrder: DEFAULT_ORDER_CONFIG.limitPerOrder,
          minOrderQty: DEFAULT_ORDER_CONFIG.minOrderQty,
        })
      )
      reset(DEFAULT_ORDER_CONFIG)
      toggle()
      addToast(msgResp || 'Reset to default order config', { appearance: 'success', autoDismiss: true })
    } catch (error) {
      addToast(error?.msgResp || error?.message || 'Reset failed', { appearance: 'error', autoDismiss: true })
    }
  }

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered className='prod-order-modal'>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className='prod-modal-hd'>
          <span className='prod-modal-title'>Order Settings</span>
          <button type='button' className='prod-modal-close' onClick={toggle}>
            ×
          </button>
        </div>

        <div className='prod-modal-body'>
          <div className='modal-field'>
            <span>Available stock</span>
            <input
              type='number'
              className={errors?.maxQuantity ? 'is-invalid' : ''}
              {...register('maxQuantity', {
                min: { value: 0, message: 'Must be 0 or greater' },
              })}
              onWheel={(e) => e.target.blur()}
            />
          </div>
          {errors?.maxQuantity && (
            <div className='modal-field-error'>{errors.maxQuantity.message}</div>
          )}

          <div className='modal-field'>
            <span>Limit per order</span>
            <input
              type='number'
              className={errors?.limitPerOrder ? 'is-invalid' : ''}
              {...register('limitPerOrder', {
                min: { value: 0, message: 'Must be 0 or greater' },
              })}
              onWheel={(e) => e.target.blur()}
            />
          </div>
          {errors?.limitPerOrder && (
            <div className='modal-field-error'>{errors.limitPerOrder.message}</div>
          )}

          <div className='modal-field'>
            <span>Minimum per order</span>
            <input
              type='number'
              className={errors?.minOrderQty ? 'is-invalid' : ''}
              {...register('minOrderQty', {
                min: { value: 0, message: 'Must be 0 or greater' },
              })}
              onWheel={(e) => e.target.blur()}
            />
          </div>
          {errors?.minOrderQty && (
            <div className='modal-field-error'>{errors.minOrderQty.message}</div>
          )}

          <div className='reset-link' onClick={handleReset}>
            Delete / Reset
          </div>
        </div>

        <div className='modal-footer'>
          <button type='button' className='modal-btn-cancel' onClick={toggle}>
            Cancel
          </button>
          <button type='submit' className='modal-btn-save' disabled={isSubmitting}>
            {isSubmitting && <Spinner size='sm' />}
            Save
          </button>
        </div>
      </form>
    </Modal>
  )
}

export default OrderSettingModal
